const pipe = (first, ...fs) => typeof first === 'function'
  ? (...args) => pipe(...args, first, ...fs)
  : fs.reduce((x, f) => f.call(undefined, x), first);

export default pipe;
